<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Sunway - Group Strategy.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                   Version: 4.0.0
                </div>
            </div>
        </div>
    </div>
</footer>